import React from 'react';
import { Navigate } from 'react-router-dom';

import { BankIntegrationViewContainer } from '~/borrower/domains/bankIntegrations/ui/BankIntegrationViewContainer';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';

// Fragments
const RouteBase = () => {
  const {
    user: {
      organization: { slug: borrowerKey, orgPreferences },
    },
  } = useUserAuthOrThrow();

  if (!orgPreferences?.cashBalancePreference) {
    throw Error('Failed to load borrower settings');
  }

  return (
    <BankIntegrationViewContainer
      borrowerKey={borrowerKey}
      cashBalancePreference={orgPreferences.cashBalancePreference}
    />
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <SettingsViewTemplate>
        <RouteBase />
      </SettingsViewTemplate>
    </RouteErrorBoundary>
  );
};
